import RelativeDateConnected from './RelativeDateConnected'

export default RelativeDateConnected
